export default function refreshTokens({post}: any, state: {jwt: string}): {jwt: string} {
  return post(`/auth/refresh`, state, {retryOn401: false})
}



// WEBPACK FOOTER //
// ./src/api/endpoints/auth/refresh.tsx